import React, { useState } from 'react';
import '../style.css';
import { useSelector, useDispatch } from 'react-redux';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { toast } from 'react-toastify';
import { suspendGroupApi } from '../../../store/features/suspendGroup';
import { deleteGroupApi } from '../../../store/features/deleteGroup';
import { addGroupAPI } from '../../../store/features/addGroup';
import DeletePopUp from '../DeletePopUp';
import Input from '../../common/InputField';
import CustomizedHook from '../../../pages/DashboardPages/TeamManagment/AutoCompleteDropDown';
import ButtonMain from '../../common/ButtonMain';
import { setActiveGroup, selectActiveGroup } from '../../../Redux/group';
import { ReactComponent as Close } from '../../../assets/images/teamclose.svg';
import { IconButton } from '@mui/material';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
function TeamGroup(props) {
  // State Management
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [activeDeleteUser, setActiveDeleteUser] = useState(false);
  const [teamGroupId, setTeamGroupId] = useState('');
  const [listOfUsers, setListOfUsers] = useState([]);
  const [name, SetName] = useState('');
  const [nameValid, SetNameValid] = useState(false);
  const [loading, SetLoading] = useState(false);
  const [error, setError] = useState('');
  const userData = useSelector((state) => state.loginToken);
  const uRole = userData.response?.user?.role_name;
  const dispatch = useDispatch();
  const activeGroup = useSelector(selectActiveGroup);

  const chracterPosition = (alphabet) => {
    const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
    return positionOfAlphabet;
  };

  const colorCodesForAvatar = [
    '#405261', '#FF4D4F', '#FA541C', '#FA8C16', '#FAAD14', '#EB2F96',
    '#FADB14', '#A0D911', '#52C41A', '#5CDBD3', '#9254DE', '#F759AB',
    '#2F54EB', '#722ED1', '#1890FF', '#13C2C2', '#2DB7F5', '#19BE6B',
    '#30A745', '#FA8C16', '#FAAD14', '#9254DE', '#F759AB', '#13C2C2',
    '#722ED1', '#2DB7F5',
  ];

  const { groupUser, onViewAllGroups, refreshGroupList, onEditGroup } = props;

  const handleViewAllClick = () => {
    if (onViewAllGroups) {
      onViewAllGroups();
    }
  };
  const handleButtonClick = () => {
    if (onEditGroup) {
      onEditGroup(selectedGroupId);
    }
    handleMenuClose();
  };



  // Menu Handlers
  const handleMenuClick = (event, groupId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedGroupId(groupId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedGroupId(null);
  };



  // Delete Group Handler



  // Add Group Handlers




  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  return (
    <div className="Group-Main-Container">
      <div className="Team-Group-Main-Container">
        <p className="Team-Group-Heading">{t.GROUP}</p>
        <p onClick={handleViewAllClick}
          style={{ cursor: 'pointer' }} className="Team-Group-Link">{t.VIEWGROUP}</p>
      </div>
      <div>
        {groupUser.map((item) => (
          <div className="Team-Group-Main" key={item._id}>
            <div className="Team-Group-logo">
              <p>
                {item.group_image ? (
                  <Avatar
                    src={item.group_image}
                    alt="users logo"
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                    }}
                  />
                ) : (
                  <Avatar
                    sx={{
                      bgcolor:
                        colorCodesForAvatar[
                        chracterPosition(
                          item.title.substring(0, 1).toUpperCase(),
                        )
                        ],
                    }}
                  >
                    {item.title.substring(0, 1).toUpperCase()}
                  </Avatar>
                )}
              </p>
              <div>
                <p className="group-title01">{item.title}</p>
                <p className="group-discreption">{item?.agents?.length} Members</p>
              </div>
            </div>
            <div className="Group-logo-container">
              <AvatarGroup
                max={4}
                sx={{
                  WebkitJustifyContent: 'left',
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                  },
                  '& .MuiAvatar-root:nth-of-type(2)': {
                    zIndex: 2,
                    marginLeft: '-8px',
                  },
                  '& .MuiAvatar-root:nth-of-type(3)': {
                    zIndex: 1,
                    marginLeft: '-8px',
                  },
                  '& .MuiAvatar-root:nth-of-type(4)': {
                    zIndex: 0,
                    marginLeft: '-8px',
                  },
                  '& .MuiAvatarGroup-avatar': {
                    zIndex: 5,
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '18px',
                    transition: 'filter 0.3s ease',
                    border: 'none',
                    width: 32,
                    height: 32,
                  }
                }}
              >
                {item?.agents?.map((agent, i) => (
                  <Avatar
                    key={i}
                    src={agent?.agent_image || undefined}
                    sx={{
                      bgcolor:
                        !agent?.agent_image &&
                        colorCodesForAvatar[
                        chracterPosition(agent?.full_name?.[0]?.toUpperCase() || 'A')
                        ],
                    }}
                  >
                    {!agent?.agent_image &&
                      (agent?.full_name?.[0]?.toUpperCase() || '?')}
                  </Avatar>
                ))}
              </AvatarGroup>
              {(item.title !== 'General' &&
                (uRole === 'admin' || uRole === 'admin_with_billing' || row.id === uID)) ? (
                <IconButton
                  onClick={(e) => handleMenuClick(e, item._id)}
                  size="small"
                  sx={{ ml: 1, "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" } }}
                >
                  <MoreHorizIcon />
                </IconButton>
              ) : (
                <span style={{ display: 'inline-block', width: '42px' }}></span> // 👈 
              )}

            </div>
          </div>
        ))}
      </div>

      {/* Menu Component */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          elevation: 0,
          sx: {
            filter: "none",
            color: '#405261',
            mt: '-5px',
            width: 200,
            paddingX: "8px",
            borderRadius: "8px",
            border: "1px solid #D5DCE1",
            boxShadow: "0 15px 20px 0 rgba(6, 21, 34, 0.05)",
            "& .MuiMenuItem-root": {
              px: "8px",
              py: 1,
              fontSize: '14px',
              fontFamily: 'Inter',
              color: '#405261',
              "&:hover": {
                color: "#061522",
                borderRadius: "8px",
                background: "#F9FAFA !important"
              },
            },
          },
        }}
      >

        <MenuItem onClick={() => { handleMenuClose(); handleButtonClick(); }}>
          {t.EDITGROUP}
        </MenuItem>

      </Menu>

      {/* Delete Popup */}

    </div>
  );
}

export default TeamGroup;